import AppDispatcher from '../dispatcher/AppDispatcher';
import { ActionTypes } from '../constants/AppConstants';
import KeyGoService from '../services/KeyGoService';

const CollectionStationsActions = {

    async get () {
        AppDispatcher.dispatch({ actionType: ActionTypes.GET_COLLECTION_STATIONS_STARTED });
        try {
            const stations = await KeyGoService.getCollectionLocations();
            AppDispatcher.dispatch({
                stations,
                actionType: ActionTypes.GET_COLLECTION_STATIONS_ENDED
            });
            return stations;
        } catch (error) {
            AppDispatcher.dispatch({ actionType: ActionTypes.GET_COLLECTION_STATIONS_FAILED, error });
            throw error;
        }
    },
};

export default CollectionStationsActions;



// WEBPACK FOOTER //
// ./src/actions/CollectionStationsActions.js